import { HttpErrorResponse } from '@angular/common/http';

/** Показывает причину отказа API, включая все ошибки валидации полей. */
export function getRaffleError(error: HttpErrorResponse): string {
  const body = error?.error;
  const details = Array.isArray(body?.params)
    ? body.params
        .map((item: { field?: string; message?: string }) =>
          [item?.field, item?.message]
            .filter(value => typeof value === 'string' && value.length > 0)
            .join(': '),
        )
        .filter(Boolean)
    : [];
  const message = Array.isArray(body?.message)
    ? body.message
        .filter((value: unknown) => typeof value === 'string')
        .join('; ')
    : typeof body?.message === 'string'
    ? body.message
    : '';
  const reason =
    [message, ...details].filter(Boolean).join('; ') ||
    (typeof body?.error === 'string' ? body.error : '') ||
    (typeof body === 'string' ? body : '') ||
    error?.message ||
    'Неизвестная ошибка запроса';
  return error?.status ? `HTTP ${error.status}: ${reason}` : reason;
}
